// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"aa89c0ce","125":"c6dc0403","599":"537d22c3","787":"dd464e99","922":"9604ee5c"}[chunkId] + ".chunk.js";
};